import apiClient from '@/shared/api/client'
import type { Machine } from '@/shared/types/master'

interface ListParams {
  page?: number
  page_size?: number
  plant_id?: string
  department_id?: string
  machine_status?: string
  is_active?: boolean
}

interface PaginatedResponse<T> {
  items: T[]
  total: number
  page: number
  page_size: number
}

export const machinesApi = {
  list: async (params?: ListParams): Promise<PaginatedResponse<Machine>> => {
    // Backend expects `size` (cap 1000), not `page_size`.
    // Translate here so every caller keeps using `page_size` consistently
    // with other masters' APIs.
    const { page_size, ...rest } = params ?? {}
    const sent = { ...rest, ...(page_size !== undefined ? { size: page_size } : {}) }
    const res = await apiClient.get<PaginatedResponse<Machine>>('/masters/machines', { params: sent })
    return res.data
  },

  get: async (id: string): Promise<Machine> => {
    const res = await apiClient.get<Machine>(`/masters/machines/${id}`)
    return res.data
  },

  create: async (data: Omit<Machine, 'id' | 'department_name' | 'plant_name'>): Promise<Machine> => {
    const res = await apiClient.post<Machine>('/masters/machines', data)
    return res.data
  },

  update: async (id: string, data: Partial<Machine>): Promise<Machine> => {
    const res = await apiClient.patch<Machine>(`/masters/machines/${id}`, data)
    return res.data
  },
}
